import store from '../../store/store';
import { isGuid } from './genererGuid';

export default function getNumsReseauxTempo(listeNums) {
  const isAffixe2 = store.getters['parametrage/affixe2'];
  return listeNums.filter(num => {
    if (isAffixe2) return isGuid(num);
    return !isGuid(num);
  });
}



// WEBPACK FOOTER //
// ./src/services/general/gestionNumReseauxTempo.js